module.exports = __webpack_public_path__ + "img/bravo.4d053177.png";